import React from 'react'
interface PillProps extends React.HTMLAttributes<HTMLButtonElement> {
    /**
     * Indicates wheter the pill is active or not
     */
    active?: boolean

    /**
     * The copy of the pill or any other content
     * **/
    children?: React.ReactNode
}
export const Pill = ({ className = 'js_Pill', active, ...rest }: PillProps) => {
    const activeState = active ? 'bg-brand-black text-white' : ''
    return (
        <button
            data-testid="pill"
            className={`${className} max-w-[320px] truncate text-ellipsis rounded border border-solid border-black px-4 py-2 uppercase tracking-wide ${activeState}`}
            {...rest}
        />
    )
}
